import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer>
      <div>
        <a href="https://github.com/LuisDeLeon24" target="_blank" rel="noreferrer"><GitHubIcon/></a>
        <a href="https://www.linkedin.com/in/luis-de-le%C3%B3n-1a6a32331/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
      </div>
      <p>Luis De León | Fullstack Developer | Cybersecurity Enthusiast | AI Solutions</p>
    </footer>
  );
}

export default Footer;